class PressSection extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      mainQuoteCarousel: '#QuoteCarousel',
      mainThumbnailCarousel: '#LogoCarousel'
    };
  }

  connectedCallback() {
    this._initThumbnailCarousel();
  }


  _initThumbnailCarousel() {
    const thumbnailCarousel = this.querySelector(this._selectors.mainThumbnailCarousel).swiper
    const quoteCarousel = this.querySelector(this._selectors.mainQuoteCarousel).swiper

    thumbnailCarousel.on('slideChangeTransitionEnd', function () {
      quoteCarousel.slideToLoop(thumbnailCarousel.realIndex);
      thumbnailCarousel.slides.forEach(slide => {
        slide.classList.remove('swiper-slide-active', 'swiper-slide-thumb-active');
      })
      if (thumbnailCarousel.slides.length) {
        thumbnailCarousel.slides[quoteCarousel.realIndex].classList.add('swiper-slide-active');
      }
    })

    quoteCarousel.on('slideChangeTransitionEnd', function () {
      thumbnailCarousel.slideToLoop(quoteCarousel.realIndex);
      quoteCarousel.slides.forEach(slide => {
        slide.classList.remove('swiper-slide-active');
      })
      if (quoteCarousel.slides.length) {
        quoteCarousel.slides[thumbnailCarousel.realIndex].classList.add('swiper-slide-active');
      }
    })

  }
}

customElements.define("s-press", PressSection);